/**
 * 产生随机字符串
 *
 * @param {Integer} size 生成的长度
 * @param {String} chars 自定义生成字符串的内容
 * @return {String} 生成好的随机字符串
 */
export const randomString = function (size, chars) {
  size = size || 6;
  chars =
    chars || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const max = chars.length;
  let ret = '';
  for (let i = 0; i < size; i++) {
    ret += chars.charAt(Math.floor(Math.random() * max));
  }
  return ret;
};

export const log = (str, type = 'log') => {
  let _log = console[type];
  _log(str);
};

/**
 * 拼接出搜索页的链接
 */
export const getSearchUrl = (keyword) =>
  `/learning/search/show.html?keyword=${encodeURIComponent(keyword)}`;

/*
  防抖
  @param fn function
  @param wait number
  @return function
*/
export function debounce(fn, wait) {
  let timeout = null;

  return function () {
    let context = this;
    let args = arguments;

    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      timeout = null;
      fn.apply(context, args);
    }, wait);
  };
}

/*
  节流
  @param fn function
  @param wait number
  @param maxTime number
  @return function
*/
export function throttling(fn, wait, maxTime) {
  let timeout = null;
  let startTime = Date.now();

  return function () {
    if (timeout !== null) clearTimeout(timeout);
    let curTime = Date.now();

    if (curTime - startTime >= maxTime) {
      fn();
      startTime = curTime;
    } else {
      timeout = setTimeout(fn, wait);
    }
  };
}

/*
  节流 new
  @param fn function
  @param wait number
  @param maxTime number
  @return function
*/
export function throttlingNew(fn, wait, maxTime) {
  let timeout = null;
  let startTime = Date.now();

  return async function (data) {
    if (timeout !== null) clearTimeout(timeout);
    let curTime = Date.now();

    if (curTime - startTime >= maxTime) {
      await fn(data);
      startTime = curTime;
    } else {
      timeout = setTimeout(async () => {
        await fn(data);
      }, wait);
    }
  };
}

/**
 * 检查是否在wps环境
 */
export const isInWps = () => !isServer() && !!window.cefQuery;

/**
 * 获取url上的参数
 * @param {*} name
 */
export function getURIParam(name) {
  const reg = new RegExp('(^|\\?|&)' + name + '=([^&^#]*)(\\s|&|$|#)', 'i');
  if (reg.test(location.href)) {
    return unescape(RegExp.$2.replace(/\+/g, ' '));
  }
  return '';
}

/**
 * 获取url上的参数并解析为对象
 * @param {*} url
 */
export function getURLParamsObject(url) {
  let result = {};

  if (typeof url !== 'string') {
    return result;
  }

  let params = url.slice(url.indexOf('?') + 1).split('&');

  for (let i = 0; i < params.length; i++) {
    let param = params[i].split('=');
    result[param[0]] = param[1] || '';
  }
  return result;
}

/**
 * 精品课url追加参数frpo
 * @param {*} url
 * @param {*} frpo
 */

export function jpkUrlHandler(url, frpo) {
  let paramsObject = getURLParamsObject(url);

  if (Object.keys(paramsObject).length === 0) {
    return `${url}?frpo=${frpo}`;
  }
  return paramsObject['frpo'] ? url : `${url}&frpo=${frpo}`;
}

/**
 * 时间转换为YYYY-MM-DD
 */
export function getYYYYMMDD(time) {
  if (!time) return '';

  const addZero = (val) => (val >= 10 ? val : `0${val}`);

  // 转换成毫秒
  const len = `${time}`.length;
  time = time * Math.pow(10, 13 - len);

  const date = new Date(time);
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();

  return `${y}-${addZero(m)}-${addZero(d)}`;
}

// 判断IE浏览器版本
export function getIEVersion() {
  const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  const isIE =
    userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; //判断是否IE<11浏览器
  const isEdge = userAgent.indexOf('Edge') > -1 && !isIE; //判断是否IE的Edge浏览器
  const isIE11 =
    userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  if (isIE) {
    const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
    reIE.test(userAgent);
    const fIEVersion = parseFloat(RegExp['$1']);
    if (fIEVersion == 7) {
      return 7;
    } else if (fIEVersion == 8) {
      return 8;
    } else if (fIEVersion == 9) {
      return 9;
    } else if (fIEVersion == 10) {
      return 10;
    } else {
      return 6; //IE版本<=7
    }
  } else if (isEdge) {
    return 'edge'; //edge
  } else if (isIE11) {
    return 11; //IE11
  } else {
    return -1; //不是ie浏览器
  }
}

//校验电话号
export function validatePhone(phone) {
  return /^1(3|4|5|7|8)\d{9}$/.test(phone);
}

//校验qq号
export function validateQQ(qq) {
  return /[1-9][0-9]{4,14}/.test(qq);
}

//校验email格式
export function validateMail(mail) {
  return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(mail);
}

export function toFixed(number, limit = 2) {
  if (!number) return number;

  return parseFloat(number).toFixed(limit);
}

// 转换人数
export function translateCrowd(number) {
  if (number >= 99990000) {
    return '9999万+';
  } else if (number >= 10000) {
    return `${Math.floor(number / 1000) / 10}万`;
  } else if (number >= 1000) {
    return `${Math.floor(number / 100) / 10}千`;
  }

  return number;
}

// 转换分秒
export function getmmss(time) {
  if (!time) return '';

  time = Math.round(time);

  const second = time % 60;
  const minute = Math.floor(time / 60);

  return `${minute}分${second}秒`;
}

export function gethhmmss(time) {
  let h = parseInt(time / 60 / 60 % 24);
  h = h < 10 ? '0' + h : h;
  let m = parseInt(time / 60 % 60);
  m = m < 10 ? '0' + m : m;
  let s = parseInt(time % 60);
  s = s < 10 ? '0' + s : s;
  return Number(h) > 0 ? `${h}:${m}:${s}` : `${m}:${s}`;
}

// 获取视频卡片的背景标题
export function getCourseBackgroundTitle(data) {
  const str = '<br />';
  let title = '';

  if (!data) return title;

  if (data.more && data.more.background && data.more.background.title) {
    title = data.more.background.title;
  } else if (data.background && data.background.title) {
    title = data.background && data.background.title;
  } else if (data.post_title) {
    title = data.post_title;
  } else if (data.title) {
    title = data.title;
  } else if (data.description) {
    title = data.description;
  }

  if (title) {
    title = title.replace(' ', str);
  }

  return title;
}

/**
 * 获取视频卡片的背景图类型
 * @param {*} data 视频卡片item的数据
 */
export function getCourseBackgroundType(data) {
  if (!data) return '';

  if (data.more && data.more.background && data.more.background.image) {
    return data.more.background.image;
  } else if (data.background && data.background.image) {
    return data.background.image;
  } else if (data.top_cate) {
    return `single_${data.top_cate}`;
  }

  return '';
}

/**
 * 获取视频卡片的背景图路径
 * @param {*} data 视频卡片item的数据 / 背景图类型
 */
export function getCourseBackgroundUrl(data) {
  if (!data) return '';

  let type = '';
  // 兼容类型及数据的传参
  if (typeof data === 'string') {
    type = data;
  } else {
    type = getCourseBackgroundType(data);
  }

  if (['single_vip', 'single_docer'].includes(type)) {
    type = 'single_wps';
  }

  return `//s1.vip.wpscdn.cn/web-libs/image/learning-fe/cover/${type}.png`;
}

// 获取url上的query
export function search2Query(search) {
  const query = {};

  if (!search) return query;

  if (search.indexOf('?') >= 0) {
    search = search.split('?')[1];
  }

  search.split('&').forEach((item) => {
    const arr = item.split('=');
    if (arr[1]) {
      query[arr[0]] = arr[1];
    }
  });

  return query;
}

// 将query拼接成search
export function query2Search(query, prefix = '?') {
  if (!query || !Object.keys(query).length) return '';

  return (
    prefix +
    Object.keys(query)
      .map((key) => `${key}=${query[key]}`)
      .join('&')
  );
}

/**
 * 将当前链接跳转至传入的query中
 * @param {*} q 要更新的query
 */
export function locateToQueryUrl(q) {
  const query = { ...search2Query(location.href), ...q };
  const { origin, pathname } = location;
  location.href = `${origin}${pathname}${query2Search(query)}`;
}

/**
 * 判断元素是否在页面中可见
 */
export function isEleVisible({
  ele,
  windowHeight,
  scrollTop,
  extraOffsetTop = 0, // 父容器的补充偏移量
}) {
  if (!ele) return false;
  let { offsetTop } = ele;
  offsetTop = offsetTop + extraOffsetTop;
  windowHeight = windowHeight === undefined ? window.innerHeight : windowHeight;
  scrollTop =
    scrollTop === undefined
      ? Math.abs(document.body.getBoundingClientRect().top)
      : scrollTop;

  return offsetTop >= scrollTop && offsetTop < scrollTop + windowHeight;
}

/**
 * 判断是否本地开发环境
 */
export function isDev() {
  return process.env.NODE_ENV === 'development';
}

/**
 * 判断是否在服务端
 */
export function isServer() {
  return !!process.server;
}

/**
 * 判断是否是爬虫访问
 */

export function isSpider(userAgent) {
  let ua = '';
  if (typeof userAgent == 'string') {
    ua = userAgent.toLowerCase();
  }

  if (ua.match('spider') || ua.match('bot')) {
    return true;
  } else {
    return false;
  }
}

/**
 * 过滤html标签获取文字
 */
export function filterHtml(html) {
  if (typeof html !== 'string') return '';

  let div = document.createElement('div');
  div.innerHTML = html;
  return div.innerText;
}

/**
 * 判断指定元素内是否包含另一个元素
 * @param {Element} container 包含其他元素的祖辈容器元素
 * @param {Element} contained 被其他元素包含的后代元素
 * @returns
 */
export function contains(container, contained) {
  if (!!document.documentElement.compareDocumentPosition || !!document.documentElement.contains) {
    return ((a, b) => {
      let adown = a.nodeType === 9 ? a.documentElement : a;
      let bup = b && b.parentNode;
      return a === bup || !!(bup && bup.nodeType === 1 && (
        adown.contains ?
          adown.contains(bup) :
          a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
      ));
    })(container, contained);

  } else {
    return ((a, b) => {
      if (b) {
        while ((b = b.parentNode)) {
          if (b === a) {
            return true;
          }
        }
      }
      return false;

    })((container, contained));
  }
}

/*
 * 高亮关键字
 */
export function highlightFormat(str, keyword) {
  if (!keyword) {
    return str;
  }
  // FIX: 过滤特殊字符;防止正则注入
  keyword = keyword.replace(/[\*\.\?\+\$\^\[\]\(\)\{\}\|\\\\/]/g, ($1) => `\\${$1}`);
  const reg = new RegExp(keyword, 'gi');

  return str.replace(reg, ($1) => {
    return `<span style="color:#417ff9">${$1}</span>`;
  });
}

/**
 * 超出字数剩略号展示
 */
export function ellipsisString(string, maxLength) {
  if (!string || string.length <= maxLength) {
    return string;
  }

  return string.slice(0, maxLength) + '...';
}

/**
 * 阿拉伯数字转换为带单位
 * @param number 原生数据
 * @returns 转换后结果
 */
export function getCrowd (number){
  const num = Number(number);
  if (Number.isNaN(num)) { return '0'; }

  const result = String(num);

  if (num >= 99990000) {
    return '9999万+';
  }

  if (num >= 10000) {
    return +(Math.floor(num / 1000) / 10) + '万';
  }

  if (num >= 1000) {
    return +(Math.floor(num / 100) / 10) + '千';
  }

  return result;
}
